import { AccessLevel } from '../../../types/AccessLevel';
import { SamlGroupMapping } from '../../../types/SsoConfiguration';

export interface SsoGroup {
    groupName: string;
    accessLevel: AccessLevel;
    companyAccesses?: Array<{
        companyId: string;
        accessLevel: AccessLevel;
    }>;
}

export const transformGroupMappingToArray = (samlGroupMapping: SamlGroupMapping): SsoGroup[] => {
    return Object.entries(samlGroupMapping).map(([groupName, config]) => ({
        groupName,
        accessLevel: config.accessLevel,
        companyAccesses: config.companyAccesses,
    }));
};
